import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 mb-4 text-xs font-semibold tracking-wider uppercase text-secondary-600 bg-secondary-50 rounded-full">
            Категории товаров
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            Популярные{' '}
            <span className="text-primary-500">категории</span>{' '}
            для заказа
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mb-8">
          <a
            href="https://kaspreadsheet.com/category-911-Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden h-[320px] md:h-[440px] md:row-span-2 no-underline cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Bold%20colorful%20athletic%20sneakers%20floating%20against%20vivid%20gradient%20background%20transitioning%20from%20coral%20pink%20to%20electric%20orange%2C%20dramatic%20studio%20lighting%20with%20sharp%20shadows%2C%20high%20energy%20sportswear%20editorial%2C%20glossy%20wet%20floor%20reflection%2C%20futuristic%20street%20style%20aesthetic%2C%20Nike%20and%20Adidas%20inspired%20silhouettes%2C%20extreme%20detail%20on%20textures%20and%20materials%2C%20vibrant%20commercial%20product%20photography&width=800&height=960&seq=cat-shoes-v2&orientation=portrait"
              alt="Обувь категория YOYBUY Spreadsheet"
              title="YOYBUY Spreadsheet Обувь"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <span className="inline-block px-3 py-1 text-xs font-semibold text-background-50 bg-primary-500/90 backdrop-blur-sm rounded-full">
                Обувь
              </span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-912/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden h-[200px] md:h-[210px] no-underline cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20oversized%20hoodie%20in%20dusty%20rose%20pink%20draped%20over%20rustic%20wooden%20chair%20in%20sunlit%20room%20with%20trailing%20ivy%20plant%2C%20golden%20hour%20warm%20light%20casting%20long%20shadows%2C%20bohemian%20cozy%20interior%20aesthetic%2C%20soft%20textural%20details%20on%20knit%20fabric%2C%20lifestyle%20fashion%20photography%20with%20organic%20natural%20feeling%2C%20very%20warm%20inviting%20atmosphere&width=800&height=480&seq=cat-hoodies-v2&orientation=landscape"
              alt="Худи и Свитера категория YOYBUY"
              title="YOYBUY Spreadsheet Худи и Свитера"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="inline-block px-3 py-1 text-xs font-semibold text-background-50 bg-accent-500/90 backdrop-blur-sm rounded-full">
                Худи и Свитера
              </span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-913/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden h-[200px] md:h-[210px] no-underline cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Graphic%20printed%20t-shirts%20in%20bold%20neon%20green%20and%20electric%20blue%20hanging%20on%20minimalist%20metal%20rack%20against%20raw%20concrete%20industrial%20wall%2C%20moody%20dramatic%20lighting%20with%20colored%20gels%2C%20urban%20streetwear%20editorial%20style%2C%20gritty%20contemporary%20fashion%20aesthetic%2C%20dark%20atmospheric%20background%20with%20vibrant%20product%20pops%2C%20edgy%20commercial%20photography&width=800&height=480&seq=cat-tshirts-v2&orientation=landscape"
              alt="Футболки категория YOYBUY"
              title="YOYBUY Spreadsheet Футболки"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="inline-block px-3 py-1 text-xs font-semibold text-background-50 bg-secondary-500/90 backdrop-blur-sm rounded-full">
                Футболки
              </span>
            </div>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com/search-914/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden h-[140px] md:h-[170px] no-underline cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Sleek%20black%20leather%20motorcycle%20jacket%20with%20silver%20zippers%20displayed%20on%20dark%20charcoal%20velvet%20fabric%2C%20dramatic%20side%20lighting%20creating%20moody%20contrast%2C%20luxurious%20editorial%20fashion%20photography%2C%20premium%20texture%20details%20on%20leather%20grain%20and%20metal%20hardware%2C%20sophisticated%20dark%20aesthetic%20with%20rich%20shadows%20and%20highlights%2C%20high%20end%20catalog%20style&width=600&height=400&seq=cat-jackets-v2&orientation=landscape"
              alt="Куртки YOYBUY"
              title="YOYBUY Spreadsheet категория Куртки"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-xs font-semibold text-background-50">Куртки</span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-915/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden h-[140px] md:h-[170px] no-underline cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Trendy%20wide%20leg%20denim%20jeans%20and%20tailored%20shorts%20styled%20on%20terracotta%20colored%20textured%20backdrop%2C%20bright%20Mediterranean%20afternoon%20sunlight%2C%20summer%20fashion%20editorial%20aesthetic%2C%20warm%20earthy%20orange%20and%20blue%20color%20palette%2C%20casual%20elegance%20with%20artful%20draping%20and%20folds%2C%20vacation%20lifestyle%20product%20photography%2C%20happy%20vibrant%20mood&width=600&height=400&seq=cat-pants-v2&orientation=landscape"
              alt="Штаны и Шорты YOYBUY"
              title="YOYBUY Spreadsheet категория Штаны и Шорты"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-xs font-semibold text-background-50">Штаны и Шорты</span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-916/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden h-[140px] md:h-[170px] no-underline cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Assortment%20of%20trendy%20baseball%20caps%20and%20bucket%20hats%20in%20pastel%20lavender%20mint%20green%20and%20butter%20yellow%20arranged%20on%20glossy%20white%20acrylic%20surface%2C%20soft%20diffused%20studio%20lighting%20with%20gentle%20fill%2C%20playful%20spring%20fashion%20catalog%20aesthetic%2C%20candy%20colored%20accessories%20photography%2C%20cheerful%20and%20youthful%20commercial%20style%2C%20minimal%20shadows%20clean%20composition&width=600&height=400&seq=cat-headwear-v2&orientation=landscape"
              alt="Головные уборы YOYBUY"
              title="YOYBUY Spreadsheet категория Головные уборы"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-xs font-semibold text-background-50">Головные уборы</span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-917/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden h-[140px] md:h-[170px] no-underline cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Coordinated%20matching%20athleisure%20set%20in%20sage%20green%20with%20cropped%20top%20and%20high%20waisted%20leggings%20styled%20on%20warm%20sand%20colored%20studio%20backdrop%2C%20soft%20directional%20window%20light%2C%20modern%20wellness%20fashion%20photography%2C%20calm%20and%20balanced%20composition%2C%20fitness%20lifestyle%20aesthetic%20with%20natural%20organic%20feeling%2C%20premium%20activewear%20editorial&width=600&height=400&seq=cat-sets-v2&orientation=landscape"
              alt="Комплекты YOYBUY"
              title="YOYBUY Spreadsheet категория Комплекты"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-xs font-semibold text-background-50">Комплекты</span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-918/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden h-[140px] md:h-[170px] no-underline cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Soft%20organic%20cotton%20underwear%20pieces%20in%20blush%20pink%20and%20dove%20grey%20neatly%20folded%20on%20pale%20marble%20surface%20with%20fresh%20eucalyptus%20sprigs%2C%20gentle%20morning%20light%20through%20sheer%20curtains%2C%20clean%20intimate%20wellness%20aesthetic%2C%20spa%20like%20serene%20atmosphere%2C%20premium%20lingerie%20flat%20lay%20photography%20with%20botanical%20accents%2C%20very%20calm%20and%20refined&width=600&height=400&seq=cat-underwear-v2&orientation=landscape"
              alt="Нижнее белье YOYBUY"
              title="YOYBUY Spreadsheet категория Нижнее белье"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-xs font-semibold text-background-50">Нижнее белье</span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-919/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden h-[140px] md:h-[170px] no-underline cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20soccer%20basketball%20jerseys%20in%20bold%20team%20colors%20red%20navy%20and%20white%20suspended%20dramatically%20in%20mid%20air%20against%20dark%20studio%20background%2C%20dynamic%20sports%20action%20photography%20style%2C%20fabric%20flowing%20with%20motion%20blur%20effect%2C%20stadium%20lighting%20simulation%2C%20powerful%20athletic%20energy%2C%20commercial%20sports%20apparel%20advertising%20aesthetic%20with%20dramatic%20spotlighting&width=600&height=400&seq=cat-jersey-v2&orientation=landscape"
              alt="Джерси YOYBUY"
              title="YOYBUY Spreadsheet категория Джерси"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-xs font-semibold text-background-50">Джерси</span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-920/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden h-[140px] md:h-[170px] no-underline cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Luxurious%20gold%20toned%20watches%20delicate%20chain%20necklaces%20and%20designer%20sunglasses%20artfully%20arranged%20on%20rich%20emerald%20green%20velvet%20fabric%2C%20warm%20candlelight%20glow%20creating%20intimate%20jewelry%20display%20atmosphere%2C%20high%20end%20accessories%20editorial%20photography%2C%20opulent%20textures%20with%20soft%20bokeh%20background%2C%20sophisticated%20luxury%20retail%20catalog%20style%20with%20dramatic%20warm%20lighting&width=600&height=400&seq=cat-accessories-v2&orientation=landscape"
              alt="Аксессуары YOYBUY"
              title="YOYBUY Spreadsheet категория Аксессуары"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-xs font-semibold text-background-50">Аксессуары</span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-921/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden h-[140px] md:h-[170px] no-underline cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Colorful%20designer%20backpacks%20and%20crossbody%20bags%20in%20mustard%20yellow%20cobalt%20blue%20and%20cherry%20red%20displayed%20on%20white%20minimalist%20shelving%20unit%2C%20bright%20cheerful%20studio%20lighting%2C%20playful%20accessories%20retail%20display%20photography%2C%20pop%20art%20inspired%20product%20arrangement%2C%20youthful%20energetic%20commercial%20aesthetic%2C%20clean%20sharp%20focus%20with%20vibrant%20saturated%20colors&width=600&height=400&seq=cat-bags-v2&orientation=landscape"
              alt="Сумки YOYBUY"
              title="YOYBUY Spreadsheet категория Сумки"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-xs font-semibold text-background-50">Сумки</span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-922/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden h-[140px] md:h-[170px] no-underline cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Handcrafted%20leather%20belts%20in%20rich%20cognac%20brown%20and%20deep%20burgundy%20elegantly%20coiled%20on%20weathered%20dark%20walnut%20wood%20surface%2C%20warm%20dramatic%20side%20lighting%20from%20vintage%20brass%20lamp%2C%20old%20world%20craftsmanship%20aesthetic%2C%20artisanal%20leather%20goods%20photography%2C%20masculine%20refined%20atmosphere%20with%20rich%20warm%20tones%2C%20heritage%20brand%20catalog%20style&width=600&height=400&seq=cat-belts-v2&orientation=landscape"
              alt="Ремни YOYBUY"
              title="YOYBUY Spreadsheet категория Ремни"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-xs font-semibold text-background-50">Ремни</span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-923/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden h-[140px] md:h-[170px] no-underline cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20designer%20perfume%20bottles%20with%20amber%20and%20rose%20gold%20liquid%20displayed%20on%20black%20mirror%20surface%20with%20dramatic%20rim%20lighting%2C%20scattered%20fresh%20rose%20petals%20and%20cinnamon%20sticks%2C%20luxury%20fragrance%20editorial%20photography%2C%20mysterious%20dark%20glamorous%20atmosphere%2C%20premium%20beauty%20commercial%20aesthetic%20with%20sparkling%20light%20reflections%2C%20sophisticated%20nighttime%20mood&width=600&height=400&seq=cat-perfumes-v2&orientation=landscape"
              alt="Парфюмерия YOYBUY"
              title="YOYBUY Spreadsheet категория Парфюмерия"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-xs font-semibold text-background-50">Парфюмерия</span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-924/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden h-[140px] md:h-[170px] no-underline cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Eclectic%20mix%20of%20lifestyle%20gadgets%20phone%20cases%20sunglasses%20and%20small%20electronics%20arranged%20on%20bright%20turquoise%20painted%20wooden%20surface%2C%20playful%20colorful%20product%20photography%2C%20confetti%20and%20party%20streamers%20in%20background%2C%20festive%20celebration%20shopping%20aesthetic%2C%20fun%20energetic%20commercial%20style%20with%20lots%20of%20visual%20interest%2C%20candid%20joyful%20atmosphere&width=600&height=400&seq=cat-other-v2&orientation=landscape"
              alt="Разное YOYBUY"
              title="YOYBUY Spreadsheet категория Разное"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-xs font-semibold text-background-50">Разное</span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}